import React, { useState } from 'react';

const ConversionRates = ({ rates, onRatesChange, defaultMinimized = false }) => {
  const [isExpanded, setIsExpanded] = useState(!defaultMinimized);
  
  const handleRateChange = (currency, value) => {
    const numValue = parseFloat(value) || 0;
    onRatesChange({
      ...rates,
      [currency]: numValue
    });
  };

  return (
    <div className="expense-card">
      <div className="flex items-center justify-between cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
            Tasas de Conversión desde GBP
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            Configura las tasas de cambio actuales
          </p>
        </div>
        <button 
          type="button"
          className="button-secondary text-xl"
        >
          {isExpanded ? '▼' : '▶'}
        </button>
      </div>
      
      {isExpanded && (
        <div className="mt-4 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* GBP to EUR */}
            <div className="expense-card-dark">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">€</span>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    1 GBP equals
                  </label>
                  <div className="flex items-center space-x-2">
                    <input
                      type="number"
                      step="0.001"
                      value={rates.EUR}
                      onChange={(e) => handleRateChange('EUR', e.target.value)}
                      className="input-field flex-1"
                      placeholder="1.165"
                    />
                    <span className="text-white font-semibold">EUR</span>
                  </div>
                </div>
              </div>
            </div>

            {/* GBP to BRL */}
            <div className="expense-card-dark">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-green-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">R$</span>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    1 GBP equals
                  </label>
                  <div className="flex items-center space-x-2">
                    <input
                      type="number"
                      step="0.001"
                      value={rates.BRL}
                      onChange={(e) => handleRateChange('BRL', e.target.value)}
                      className="input-field flex-1"
                      placeholder="6.36"
                    />
                    <span className="text-white font-semibold">BRL</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-gradient-to-r from-orange-700 to-yellow-400 rounded-xl text-white">
            <h3 className="font-semibold mb-2">Ejemplos de uso:</h3>
            <div className="text-sm space-y-1">
              <p>• Si 1 GBP = 1.165 EUR, ingresa <strong>1.165</strong></p>
              <p>• Si 1 GBP = 6.36 BRL, ingresa <strong>6.36</strong></p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConversionRates; 